// extracted by mini-css-extract-plugin
module.exports = {"clearInputIcon":"RecordDetails_clearInputIcon__3B0vB"};